<template>
  <div>
    <template v-if="pslStyle === 'switch'">
      <v-switch
        :hide-details="hideDetails"
        @change="onInput"
        v-model="innerValue"
        v-bind="$attrs"
        :aria-label="ariaLabel"
      >
        <template v-slot:label>
          <span :class="labelClass">{{ label }}</span>
        </template>
      </v-switch>
    </template>

    <template v-if="pslStyle === 'checkbox'">
      <v-checkbox
        v-model="innerValue"
        color="psdarkgreen"
        :hide-details="hideDetails"
        @change="onInput"
        :aria-label="ariaLabel"
      >
        <template v-slot:label>
          <span :class="labelClass">{{ label }}</span>
        </template>
      </v-checkbox>
    </template>

    <template v-if="pslStyle === 'button'">
      <BaseButton
        flat
        iconSize="40"
        iconColor="psdarkgreen"
        fontSize="font-18"
        height="auto"
        class="px-0 py-1 button-toggle"
        :text="label"
        :icon="innerValue ? 'mdi-minus-circle' : 'mdi-plus-circle'"
        max-width="100%"
        @click="onClick"
        :aria-label="ariaLabel"
      />
    </template>
  </div>
</template>

<script>
import BaseButton from "@/components/BaseComponents/BaseButton";

export default {
  name: "BaseToggle",
  components: {
    BaseButton,
  },
  props: {
    label: String,
    labelClass: String,
    hideDetails: {
      type: [Boolean, String],
      default: "auto",
    },
    pslStyle: {
      type: String,
      default: "button",
    },
    value: Boolean,
    ariaLabel: String,
  },
  data() {
    return {
      innerValue: false,
    };
  },
  watch: {
    // Handles internal model changes.
    innerValue(value) {
      this.$emit("input", value);
    },
    // Handles external model changes.
    value(val) {
      if (val !== this.innerValue) {
        this.innerValue = val;
      }
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
  methods: {
    onInput(val) {
      this.$emit("change", val);
    },
    onClick() {
      this.innerValue = !this.innerValue;
      this.$emit("click", this.innerValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.button-toggle {
  :deep(.v-btn__content) {
    max-width: 100%;
    white-space: normal;
    text-align: left;
  }
}
</style>
